<template>
  <div class="loans-payment">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex xs12 md6">
      	 <va-card>
           <template #title>
    {{ $t('loans.payment') }}
  </template>
          <form @submit.prevent="onsubmit">

            <va-select
              class="mb-4"
              label="Loan"
              v-model="ln_no"
              textBy="loan_product_name"
              :loading = "loadSelect"
              :options="loans"
              key-by="loan_no"
            />

            <va-input
              :label="$t('amount')"
              type="number"
              v-model="formdata.amount"
              :error="!!amountErrors.length"
              :error-messages="amountErrors"
            />

            <va-select
              class="mb-4"
              label="Payment Method"
              v-model="formdata.payment_mode"
              textBy="description"
              :options="PaymentOptions"
              key-by="id"
              @input="setSelected"
            />

            <va-input v-if="showFosa"
              :label="$t('fosa')"
              :readonly = "true"           
              v-model="formdata.paybill_code"
              :error="!!fosaErrors.length"
              :error-messages="fosaErrors"
            />

            <va-input 
              v-if="showMpesa"
              :label="$t('mpesa-phone')"
              v-model="formdata.phone_no"           
              :error="!!phoneErrors.length"
              :error-messages="phoneErrors"
            />	

        	 	<div class="row mt-5">            
                <va-button type="submit" :disabled="isLoading">
                  {{ $t('forms.controls.submit') }}
                </va-button>                        
            </div>
          </form>
      	 </va-card>
      </div>
    </div>
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.confirm') "     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
      <table class="va-table va-table--striped va-table--hoverable" width="100%">
        <tbody>
          <tr>
            <td>Loan No</td>
            <td style="text-align: right;">{{ loan_no }}</td>
          </tr>
          <tr>
            <td>Payment Method</td>
            <td style="text-align: right;">{{ payment_method }}</td>
          </tr>
          <tr v-if="showMpesa">
            <td>Payment Phone No</td>
            <td style="text-align: right;">{{ paying_phone_no }}</td>
          </tr>
          <tr v-if="showFosa">
            <td>Payment Account</td>
            <td style="text-align: right;">{{ accdetails.accname }}</td>
          </tr>
          <tr>
            <td>Transaction Charge</td>
            <td style="text-align: right;">{{ charge | Currency }}</td>
          </tr>
          <tr>
            <td>Current Loan Balance</td>
            <td style="text-align: right;">{{ loan_balance | Currency }}</td>
          </tr>          
          <tr>
            <td>Payment Amount</td>
            <td style="text-align: right;">{{ payment_amount | Currency }}</td>
          </tr> 
          <tr>
            <td>New Loan Balance</td>
            <td style="text-align: right;">{{ loan_balance - payment_amount  | Currency }}</td>
          </tr>          
        </tbody>
      </table>
    </va-modal>
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loans-payment',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),     
      loan_no : '',
      isLoading: null,
      ln_no : '',
      loans: [
        {
          loan_no: '',
          loan_product_name: 'select an Option',
        }
      ],
      loading: false,
      loadSelect:false,
      processingError: false,
      payment_method : '',
      finalPost : '',
      formdata:{
      	payment_mode:'',
        phone_no:'',
        amount:'',
        paybill_code:'',        
        user: '',
      },
      amountErrors : [],
      fosaErrors : [],
      phoneErrors: [],
      showMpesa : false,
      showFosa: false,
      showConfirmModal : false, 
      accname: '',
      phone_no: '',
      charge:'',
      loan_balance:'',
      payment_amount:'',
      paying_phone_no:'',
      PaymentOptions: [
        {
          id: '',
          description: 'select an Option',
        },
        {
          id: 'mpesa',
          description: 'M-pesa',
        },
        {
          id: 'fosa',
          description: 'Fosa',
        },
      ],
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    formReady () {
      return !this.amountErrors.length && !this.fosaErrors.length && !this.phoneErrors.length
    },
  },
  methods : {
    onsubmit (e) {
      e.preventDefault();
      console.log(this.ln_no.loan_no)
      this.processingError = false;
      this.amountErrors = this.formdata.amount ? [] : ['Amount is required']
      if (this.showFosa) {this.fosaErrors = this.formdata.paybill_code ? [] : ['You Don\'t have an active fosa account']} 
      if (this.showMpesa) {this.phoneErrors = this.formdata.phone_no  ? [] : ['Phone No is required']} 
      if (this.formReady) {
        this.isLoading = true
        this.paying_phone_no = this.formdata.phone_no      
       
        const selected = this.formdata.payment_mode 
        this.formdata.payment_mode =this.formdata.payment_mode.id
        const postdata = {
          data: this.formdata,
          loan: this.ln_no.loan_no
        }   

      
        this.loading = true
        var self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${this.$apiUrl}GetLoanDetails`, postdata, config)
        .then(function (res) {            
          self.loading = false
          self.formdata.payment_mode = selected
          self.payment_method = selected.description
                   
          const response = res.data
          self.finalPost = response
          if(response.success == '2'){
            self.phoneErrors = ['Please enter a valid safaricom line']
            self.isLoading = false
          } 
          if(response.success == '1'){              
            self.charge = response.amount
            self.payment_amount = response.data.data.amount
            self.loan_balance = response.acc_details.balance
            self.showConfirmModal = true;
          } 
                    
        })
        .catch(function (error) {
            console.log(error)
        })
      } 
    },
    FinalPost () {
      this.isLoading = true
      const msg = this.showMpesa ? "Enter M-pesa pin on payong phone to complete" : "Thank you !" ;
      this.loading = true
      var self = this
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${this.$apiUrl}repayLoanFinal`, this.finalPost, config )
      .then(function (res) {
        self.loading = false
        const resp = res.data
        if(resp.response.success == '1'){              
          self.showToast(`Payment Processed succefully ${msg}`, {
            position: 'bottom-right',
            icon: "fa-check",
            duration: 2500,
          })
          setTimeout( () => self.$router.go(-1), 2500);
          self.isLoading = false
        } else {
          self.processingError = true
        }
                  
      })
      .catch(function (error) {
          console.log(error)
      })
    },
  	setSelected(value){
  		const val = value.id
      if (val) {
        if (val == 'fosa'){
          this.showFosa = true
          this.showMpesa = false
        } else {
          this.showMpesa = true
          this.showFosa = false
        } 
      }
  	},

    GetMemberLoans () {
      this.loadSelect = true
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetMemberLoans`, self.userData.user_id, config)
        .then(function (res) {
          self.loadSelect = false
          self.loading = false
          res = res.data
          self.loans = res
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  },
  created () {  
    this.GetMemberLoans()   
  	this.formdata.phone_no  = this.userData.mobile_number
    this.formdata.user  = this.userData.user_id
    this.formdata.paybill_code  = this.accdetails.accname
    if(this.userData.is_registered_mobile_user !=  1) {
      var id = 'fosa'
      this.PaymentOptions = this.PaymentOptions.filter((e)=>e.id !== id )
    }
  }
}
</script>